<div class="flex">
    <button
        mat-icon-button
        [matMenuTriggerFor]="userActions"
        [matTooltip]="
            ('codext.loggedInAs' | transloco) +
            ' ' +
            userService.user?.first_name +
            ' ' +
            userService.user?.last_name
        ">
        @if (userImagePath) {
            <img
                class="w-6 h-6 max-w-6 max-h-6 min-h-6 min-w-6 rounded-full object-cover"
                [src]="environment.apiURL + userImagePath" />
        }
        @if (!userImagePath) {
            <div
                class="w-6 h-6 max-w-6 max-h-6 min-h-6 min-w-6 rounded-full bg-gray-300 flex justify-center items-center">
                <div class="text-[10px]">{{ userService.user?.login }}</div>
            </div>
        }
        <!-- <img
    class="w-7 h-7 rounded-full"
    *ngIf="showAvatar && userService.user?.avatar"
    [src]="userService.user?.avatar" /> -->
        <!-- <mat-icon
    *ngIf="!showAvatar || !userService.user?.avatar"
  [svgIcon]="'heroicons_outline:user-circle'"></mat-icon> -->
    </button>

    <mat-menu
        [xPosition]="'before'"
        #userActions="matMenu">
        <button
            mat-menu-item
            class="flex md:hidden">
            @if (environment.isTestSystem || headlineService.enabled) {
                <mat-checkbox
                    [matTooltip]="
                        translocoService.getActiveLang() === 'de'
                            ? 'Altes System'
                            : 'Old system'
                    "
                    [(ngModel)]="headlineService.showIframe"
                    (change)="headlineService.toggleOldSystem()">
                </mat-checkbox>
            }
            <span>{{
                translocoService.getActiveLang() === 'de' ? 'Alt' : 'Old'
            }}</span>
        </button>
        <button
            mat-menu-item
            (click)="goToMyData()">
            <mat-icon
                [svgIcon]="'heroicons_outline:rectangle-stack'"></mat-icon>
            <span>{{ 'p_usd' | transloco }}</span>
        </button>
        <button
            mat-menu-item
            (click)="goToMyDataSettings()">
            <mat-icon [svgIcon]="'mat_outline:settings'"></mat-icon>
            <span>{{ 'pusd.tab_1_title' | transloco }}</span>
        </button>
        <mat-divider class="my-2"></mat-divider>
        <button
            class="flex md:hidden"
            mat-menu-item
            (click)="signOut()">
            <mat-icon
                [svgIcon]="
                    'heroicons_outline:arrow-right-on-rectangle'
                "></mat-icon>
            <span>{{ 'group.logout' | transloco }}</span>
        </button>
    </mat-menu>
    <button
        class="hidden md:block"
        mat-icon-button
        [matTooltip]="'group.logout' | transloco"
        (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
            class="mt-[5px]"></mat-icon>
    </button>
</div>
